import  { useEffect, useRef, useState } from 'react'

const UseEligibility = (eligibilityData) => {
    const itemsRef = useRef([]);
    const [visibleItemId, setVisibleItemId] = useState("home");
    const timeRef = useRef('')
    const distinctBenifits = eligibilityData.patientEligibilityBenefits.reduce((a, b) => !a.some(v => v.benefitCode === b.benefitCode) ? [...a, b] : a, [])

    const allBenefits = [...eligibilityData.patientEligibilityBenefits]
    allBenefits.sort((a, b) => {
        const order = distinctBenifits.map(sss => sss.benefitCode);
        return order.indexOf(a.benefitCode) - order.indexOf(b.benefitCode);
    });

    let arrr = []
    distinctBenifits.forEach((b) => {
        let fff = eligibilityData.patientEligibilityBenefits.filter((eb) => eb.benefitDescription === b.benefitDescription)
        arrr.push({ [b.benefitDescription]: fff })
    })



    const subscriberInfo = {
        subscriberFirstName: eligibilityData.subscriberFirstName,
        subscriberLastName: eligibilityData.subscriberLastName,
        subscriberId: eligibilityData.subscriberId,
        subscriberGender: eligibilityData.subscriberGender,
        subscriberGroupNumber: eligibilityData.subscriberGroupNumber,
        eligibilityDate: eligibilityData.eligibilityDate,
        eligibilityResultDate: eligibilityData.eligibilityResultDate,
        subscriberDOB: eligibilityData.subscriberDOB,
        subscriberAddress1: eligibilityData.subscriberAddress1,
        subscriberGroupName: eligibilityData.subscriberGroupName,
        benefitDescription: "home"
    }
    allBenefits.unshift(subscriberInfo)
    arrr.unshift(subscriberInfo)

    const handleClick = (detail) => {
        const element = itemsRef.current.find((item) => item.id === detail.benefitDescription);

        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
        }
    };
    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {

                    if (entry.isIntersecting && entry.intersectionRatio >= .8) {
                        timeRef.current = setTimeout(() => {
                            setVisibleItemId(entry.target.id);
                        }, 100);

                        // timeRef.current = setTimeout(() => {
                        //     setVisibleItemId(entry.target.id);
                        // }, 500);
                    } else {
                        if (timeRef.current) {

                            clearTimeout(timeRef.current)
                        }
                        // if (timeRef.current) {
                        //     clearTimeout(timeRef.current)
                        // }
                    }
                });
            },
            { threshold: .8 } // Adjust as needed
        );

        itemsRef.current.forEach((item) => {
            if (item) observer.observe(item);
        });

        return () => {
            itemsRef.current.forEach((item) => {
                if (item) observer.unobserve(item);
            });
        };
    }, [itemsRef.current.length]);
    return [handleClick, visibleItemId, distinctBenifits, arrr, itemsRef]
}

export default UseEligibility